import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Label } from '@bingads-webui-react/primitive';
import { ValidationGroup, Input } from '@bingads-webui-react/primitive-validation';
import { sampleSchema } from './sample-schema';
import { AdjustmentType, isDataExclusion } from '../adjustment-type';

const schema = sampleSchema;

function getStyles() {
  return {
    textInput: {
      width: '50%',
      marginBottom: '16px',
      '& div[role=alert]': {
        paddingTop: 5,
        fontSize: 12,
      },
    },
  };
}

function SeasonalityTextInput(props) {
  const {
    classes,
    i18n,
    showValidationError,
    onValidate,
    onChangeName,
    onChangeDescription,
    name,
    description,
    adjustmentType,
  } = props;

  function onChange(result) {
    onValidate(result.isValid);
    onChangeName(result.data.Name);
    onChangeDescription(result.data.Description);
  }

  return (
    <ValidationGroup validationProps={{ schema, onValidate: onChange }}>
      <div className={`seasonality-name-input ${classes.textInput}`}>
        <Label id="seasonality-name-label">
          {i18n.getString(_TL_('Name'))}
        </Label>
        <Input
          validationProps={{ field: 'Name', alwaysShowError: showValidationError }}
          placeholder={i18n.getString(isDataExclusion(adjustmentType) ?
            _TL_('Enter a name for your data exclusion') :
            _TL_('Enter a name for your seasonality adjustment'))}
          value={name}
          aria-labelledby="seasonality-name-label"
        />
      </div>
      <div className={`seasonality-description-input ${classes.textInput}`}>
        <Label id="seasonality-description-label">
          {i18n.getString(_TL_('Description'))}
        </Label>
        <Input
          validationProps={{ field: 'Description', alwaysShowError: showValidationError }}
          placeholder={i18n.getString(isDataExclusion(adjustmentType) ?
            _TL_('Enter a description for your data exclusion (optional)') :
            _TL_('Enter a description for your seasonality adjustment (optional)'))}
          value={description}
          aria-labelledby="seasonality-description-label"
        />
      </div>
    </ValidationGroup>
  );
}

SeasonalityTextInput.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({}).isRequired,
  onChangeName: PropTypes.func.isRequired,
  onChangeDescription: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  adjustmentType: PropTypes.oneOf([AdjustmentType.DataExclusion, AdjustmentType.SeasonalityAdjustment]).isRequired,
  showValidationError: PropTypes.bool,
  name: PropTypes.string,
  description: PropTypes.string,
};

SeasonalityTextInput.defaultProps = {
  showValidationError: false,
  name: undefined,
  description: undefined,
};

const Wrapped = _.compose(
  withI18nConsumer,
  Comp => withDefaultStyles(Comp, getStyles)
)(SeasonalityTextInput);

export { Wrapped as SeasonalityTextInput };
